import { Route, Routes, Navigate, useNavigate } from "react-router-dom"
import { useMemo } from 'react';
// import LibraryHome from './views/Home'
// import LibrarySearch from './views/Search'
// import BackStageLayout from './../../theme/layout_backend2'
// import BackStageSider from './views/BackStage/Sider'
import PortalMainPage from './views/BackStage/portal_main_page'
// import BackStageHome from './views/BackStage/Home'
// import BackStageCataloging from './views/BackStage/Cataloging'
import BackStageCirculation from './views/BackStage/Circulation'
// import BackStageCirculationReserve from './views/BackStage/CirculationReserve'
// import BackStageCirculationBookList from './views/BackStage/CirculationBookList'
// import BackStageCirculationPlace from './views/BackStage/CirculationPlace'
// import BackStageCirculationHolds from './views/BackStage/CirculationHolds'
import BackStageCirculationRules from './views/BackStage/CirculationRules'
// import BackStageTest from './views/BackStage/test'
// import BackStagReceivingHolds from "./views/BackStage/ReceivingHolds"
// import BackStagePatrons from './views/BackStage/SearchPatrons'
// import SearchPatrons from './views/BackStage/SearchPatrons'
import BackStageLabelPrint from './views/BackStage/LablePrint'
// import BackStageBarcodePrint from './views/BackStage/BarcodePrint'
import BackStageStageMARCRecord from './views/BackStage/StageMARCRecord'
import BackStageManageMARCRecord from './views/BackStage/ManageMARCRecord'
// import BackStageMARCRecord from './views/BackStage/MARCRecord'
import BackStageAddMARC from "./views/BackStage/AddMARC"
// import BackStagePatronCategories from "./views/BackStage/PatronCategories"
// import BackStageNewOrEditPatronCategory from "./views/BackStage/NewPatronCategory"
// import BackStageNewOrEditPatron from "./views/BackStage/NewPatron"
// import BackStagePatronPermissions from "./views/BackStage/PatronPermissions"
// import BackStagePatronCheckout from "./views/BackStage/PatronCheckout"
import BackStageSearchZ3950 from "./views/BackStage/SearchZ3950/SearchZ3950"
import BackStageBookDetail from "./views/BackStage/BookDetail/BookDetail"
// import BackStageUploadImage from "./views/BackStage/UploadImage"
// import BackStageListItems from "./views/BackStage/ListItems"
// import BackStageNewOrEditItem from "./views/BackStage/NewOrEditItem"
import BackStageBookDetailItems from "./views/BackStage/BookDetail/BookDetailItems"
// import BackStageExportData from "./views/BackStage/ExportData"
// import BackStageCheckIn from "./views/BackStage/CheckIn"
// import BackStageCheckOut from "./views/BackStage/CheckOut"
import BackStageCheckOutHistory from "./views/BackStage/CheckOutHistory"
import BackStageCheckOutSetting from "./views/BackStage/CheckOutSetting"
import BackStageRenewSetting from "./views/BackStage/RenewSetting"
// import BackStageHoldSetting from "./views/BackStage/HoldSetting"
import BackStageHoldSetting from "./components/HoldSettingProTableOt"
import BackStageHoldPriority from "./components/HoldPriorityProTableOt"
// import BackStagePatronDetail from './views/BackStage/PatronDetail'
// import BackStageBookDetailPlaceHolds from './views/BackStage/BookDetailPlaceHolds'
// import BackStageBookDetailHolds from './views/BackStage/BookDetailHolds'
import LibraryLayout from './/views/Layout'
// import BackStageAuthorisedValues from "./views/BackStage/AuthorisedValues"
// import BackStageAuthorisedValuesCategory from "./views/BackStage/AuthorisedValuesCategory"
// import BackStageAuthorisedValuesCategoryNew from "./views/BackStage/AuthorisedValuesCategoryNew"
// import BackStageAuthorisedValuesNewOrEdit from "./views/BackStage/AuthorisedValuesNewOrEdit"
import { Mainlayout } from "../ui/ot"
// import ReaderService from "../charts/views/ReaderService"
// import SearchFunction from './views/SearchFunction'
// import CategorizationGroupONE from './views/CategorizationGroupONE'
// import CategorizationGroupTWO from './views/CategorizationGroupTWO'
// import BackStageAuthority from "./views/BackStage/authority/SearchAuthority"
import SerialsManagement from "./views/BackStage/serials_management"
import SerialFrequencyManagement from './views/BackStage/serial_frequency_management'
import SerialCodeManagement from './views/BackStage/serial_code_management'
import LibraryTransferLimitManagement from './views/BackStage/library_transfer_limit_management'
import LibraryTransferManagement from './views/BackStage/library_transfer_management'
// import BSTable from './components/BSTable' 
import DepartmentPatronCategories from './views/department_patron_categories'
import StaffPatron from "./views/staff_patron"
import Staff from '../../components/organization_structure/personal_information_management';
import DepartmentRoleManagement from '../../components/organization_structure/department_role_management';
import DepthDataManagement from '../../components/organization_structure/depth_data_management';
import MainRouteOnlinePublicCatalogQueryConstruction from "../../components/online_public_catalog_query_construction/main_route"
import MainRouteKoha from "../koha/main_route"
import MainCataloging from './../../components/cataloging/mian_route'
import RouteOrganizationStructure from './../../components/organization_structure/MainRoute';
import MainRouteLibraryFront from './MainRouteFront'
import NavBarBackend from './../../theme/layout_backend2.js'
import { useStaffDivergeSelf } from "../permission_management/controllers/staff_diverge_self_controller";
import { useEffect } from "react"
// import AppMainRoute from '../../pages/app/MainRoute'
import PersonalInfoQuery from "./views/personal_info_query"
import PersonalStudy from "./views/personal_study"
import ReaderReviewManagement from "./views/reader_review_management"
import NewArrivalsList from "./views/new_arrivals_list_management"
import SystemBackupSettings from "./views/system_backup_settings"
import MessageInbox from "./views/message_inbox"
import JWT from "./jwt"
import { NoPermission, LoginRequired } from "../ui/ot"
import Borrow from './views/borrow'
import BookReturn from './views/book_return'
import OverdueProcessing from './views/overdue_processing'
import LibrarySwitchLayout from "./views/library_switch_layout"
import axios from "axios";
import AppMainRoute from "./../../pages/app/MainRoute"
import ComponentLayout from '../component_layout/afatsLayout'
import LibraryBookDetail from "./views/book_detail_barcode_filter"
import CollectionBarcodeOverview from "./views/BackStage/collection_barcode_overview"
import NewArrivalsListShow from "./views/new_arrivals_list_show"
import LibraryOpeningHoursManagement from "../project_library/views/library_opening_hours_management";
import LibrarySerialReceive from "./views/library_serial_receive";
import SpaceManagement from './..//reservation_registration_and_space_management/views/space_management'
import WeekManagement from './../reservation_registration_and_space_management/views/week_management'
import LibraryOpenHourManagement from '../project_library/library_open_hour_management';
import HolidayManagement from '../reservation_registration_and_space_management/views/holiday_management'
import HolidayDetailManagement from '../reservation_registration_and_space_management/views/holiday_detail_management'

import { DailyCirculationStatistics } from "./views/daily_circulation_statistics";
import { CirculationTrendAnalysis } from './views/circulation_trend_analysis'
import { OverdueReport } from './views/overdue_report'
const MainRoute = ({
    admin,
    menuData = [],
    defaultAdminRoute = '/library/backstage',
    defaultNotAdminRoute = '/library/online_public_catalog_query_construction',
}) => {


    const navigate = useNavigate();
    const { StaffDivergeSelfData, getStaffDivergeSelfData } = useStaffDivergeSelf({})

    const getSideBar = (StaffDivergeSelfData) => {
        const permissionGroups = StaffDivergeSelfData?.find(_ => true)?.permission_data || [];
        const barcodeOverviewPath = '/library/backstage/collection_barcode_overview';
        const hasBarcodeOverview = permissionGroups.some(group =>
            group?.permission_data?.some(item => item?.url === barcodeOverviewPath)
        );
        // 尚未設定獨立權限時，將條碼總覽放在既有的館藏維護入口旁。
        let barcodeOverviewAdded = hasBarcodeOverview;
        const getMenuItems = (permissions = []) => permissions.flatMap(item => {
            const menuItem = { key: item?.url, label: item?.permission_name };
            if (item?.url === '/library/backstage/BookDetail' && !barcodeOverviewAdded) {
                barcodeOverviewAdded = true;
                return [menuItem, { key: barcodeOverviewPath, label: '館藏條碼總覽' }];
            }
            return [menuItem];
        });

        return permissionGroups.flatMap(group => {
            const children = getMenuItems(group?.permission_data || []);
            return group?.permission_group_name === 'default'
                ? children
                : [{ label: group?.permission_group_name, children }];
        });
    }
    useEffect(() => {
        getStaffDivergeSelfData({})
    }, [])
    const jwt = admin ? {
        element: <JWT
            loginPath="/login"
            noPermissionRoute="/library/backstage/no_permission"
            exceptionPathData={[
                '/library',
                '/library/backstage',
                '/library/backstage/no_permission',
                '/library/backstage/department_patron_categories',
                '/library/backstage/depth',
                '/library/backstage/EditMARC',
                '/library/backstage/BookDetailItems',
                // '/library/backstage/system_backup_settings'
                // '/library/online_public_catalog_query_construction',
                // '/library/personal_info_query', //前台個人資訊
                // '/library/personal_study', //前台個人書房

                // , '/library/backstage/space_management'
                 '/library/backstage/week_management',
                 '/library/backstage/holiday_management',
                 '/library/backstage/holiday_management/detail'
            ]}
        />
    } : {
        element: <JWT
            loginPath="/user_login"
            noPermissionRoute="/library/login_required"
            exceptionPathData={[
                '/library/online_public_catalog_query_construction',
                // '/library/backstage/department_patron_categories',
                // '/library/backstage/depth'
                // '/library/personal_info_query', //前台個人資訊
                // '/library/personal_study', //前台個人書房
                // '/library/message_notification', //前台個人訊息通知
            ]}
        />
    }
    const app = localStorage.getItem("app") ?? null;
    const isLogin = Boolean(localStorage.getItem('access_token')); // or 根據你的登入判斷條件
    const menuDataFronted = useMemo(() => [
        {
            key: "/",
            label: "圖書入口網",
            path_check: 1
        },
        {
            key: "/library/online_public_catalog_query_construction/bib_search_function",
            label: "館藏查詢",
            path_check: 0
        },
        {
            key: "/library/online_public_catalog_query_construction/display_list",
            label: "書單展示",
            path_check: 0
        },
        ...(!isLogin ? [{
            key: "/user_login",
            label: "讀者登入",
            path_check: 0,
            onClick: () => {
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('access_token');
                localStorage.removeItem('lineBind');
                axios.post('/logout')
                    .then(() => navigate("/user_login"))
                    .catch(console.error);
            }
        }] : []),
        ...(isLogin ? [
            {
                label: "個人專區",
                children: [
                    {
                        key: "/library/personal_info_query",
                        label: "個人資料",
                        path_check: 0
                    },
                    {
                        key: "/library/personal_study",
                        label: "個人書房",
                        path_check: 0
                    },
                    {
                        key: "/library/message_notification",
                        label: "個人通知",
                        path_check: 0
                    }
                ]
            }
        ] : []),
        ...(isLogin ? [{
            key: "/user_login",
            label: "登出",
            path_check: 0
        }] : [])
    ], [isLogin]);

    return (<>
        <Routes>
            <Route path="/" element={<Navigate to={admin ? defaultAdminRoute : defaultNotAdminRoute} replace />} />
            {admin && <>
                <Route path={''}
                    {...jwt}
                >
                    <Route path="backstage" element={<NavBarBackend titleUpdaterOpen={true} prefixTitle={'iRead圖書自動化系統'} not_sider menuData={getSideBar(StaffDivergeSelfData)} selfSettingButtonMode={false} selfSettingRoute='/organization_structure/home' />}  >
                        <Route path="" element={<Mainlayout />}>
                            <Route path="" element={<LibrarySwitchLayout />}>
                                <Route path={''} element={<PortalMainPage />} />
                                <Route path={'no_permission'} element={<NoPermission homePagePath="/library/backstage" />} />
                                {/* <Route path={'Cataloging'} element={<BackStageCataloging />} /> */}
                                <Route path={'LabelPrint'} element={<BackStageLabelPrint permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data_all?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "LabelPrint"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                {/* <Route path={'BarcodePrint'} element={<BackStageBarcodePrint />} /> */}
                                <Route path={'StageMARCRecord'} element={<BackStageStageMARCRecord permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data_all?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "StageMARCRecord"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                <Route path={'ManageMARCRecord'} element={<BackStageManageMARCRecord permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data_all?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "ManageMARCRecord"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                {/* <Route path={'MARCRecord'} element={<BackStageMARCRecord />} /> */}
                                <Route path={'AddMARC'}>
                                    <Route path={''} element={<BackStageAddMARC permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data_all?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "AddMARC"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                </Route>
                                {/* MainRouteKoha 內含授權值管理、分館管理 */}
                                <Route path={'*'}
                                    element={<MainCataloging
                                        user_permission_data={StaffDivergeSelfData?.find(_ => true)?.permission_data_all}
                                        allRouteKeys={[
                                            "bibliographic_management",
                                            "serial_frequency_management",
                                            "serial_code_management",
                                            "serials_management",
                                            "serial_orderlist_management",
                                            "framework_management",
                                            "tag_structure_management",
                                            "subfield_structure_management",
                                            "scrapped_list_management",
                                            "duplicate_check",
                                            "book_image_upload",

                                        ]}
                                    />}
                                />
                                <Route path={'serial_receive'} element={<LibrarySerialReceive user_permission_data={StaffDivergeSelfData?.find(_ => true)?.permission_data_all} />} />

                                <Route path={'backend_basic_settings/*'} element={<MainRouteKoha user_permission_data={StaffDivergeSelfData?.find(_ => true)?.permission_data_all} />} />

                                <Route path={'EditMARC'} element={<BackStageAddMARC />} />
                                <Route path={'SearchZ3950'} element={<BackStageSearchZ3950 permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data_all?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "SearchZ3950"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                {/* <Route path={'UploadImage'} element={<BackStageUploadImage />} /> */}
                                {/* <Route path={'AddItem'}>
                                    <Route path={''} element={<BackStageListItems />} />
                                    <Route path={':biblionumber'} element={<BackStageNewOrEditItem />} />
                                </Route> */}
                                {/* <Route path={'EditItem'}>
                                    <Route path={':biblionumber/:itemnumber'} element={<BackStageNewOrEditItem />} />
                                </Route> */}
                                {/* <Route path={'ExportData'} element={<BackStageExportData />} /> */}

                                {/* <Route path={''} element={<BackStageSider type={'BookDetail'} />}> */}

                                {/* bib_biblionumber */}
                                {/* <Route path={'BookDetail/:bib_biblionumber'} element={<BackStageBookDetail />} />  */}
                                <Route path={'BookDetail'} element={<LibraryBookDetail />} />
                                <Route path={'collection_barcode_overview'} element={<CollectionBarcodeOverview />} />

                                {/* itemnumber */}
                                {/* <Route path={'BookDetailItems/:itemnumber'} element={<BackStageBookDetailItems />} /> */}
                                <Route path={'BookDetailItems'} element={<BackStageBookDetailItems />} />

                                {/* <Route path={'BookDetailPlaceHolds'} element={<BackStageBookDetailPlaceHolds />} /> */}

                                {/* itemnumber */}
                                {/* <Route path={'BookDetailHolds/:itemnumber'} element={<BackStageBookDetailHolds />} /> */}
                                {/* </Route> */}

                                {/* Circulation */}
                                <Route path={'Circulation'}>
                                    {/* <Route path={''} element={<BackStageCirculation />} /> */}
                                    <Route path={''} element={<BackStageCirculationRules permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "Rules"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                    {/* <Route path={'CirculationCheckout'} element={<SearchPatrons />} /> */}
                                    {/* <Route path={''} element={<BackStageSider type={'CirculationReserve'} />} >
                                        <Route path={'CirculationReserve'} element={<SearchPatrons />} />
                                        <Route path={'CirculationReserve/:biblionumber'} element={<BackStageCirculationReserve />} />
                                        <Route path={'CirculationBookList'} element={<BackStageManageMARCRecord title={'預約館藏'} />} />
                                        <Route path={'CirculationPlace/:name'} element={<BackStageCirculationPlace />} />
                                        <Route path={'CirculationHolds'} element={<BackStageCirculationHolds />} />
                                    </Route> */}
                                    {/* <Route path={''} element={<BackStageSider />}>
                                        <Route path={'CheckIn'} element={<BackStageCheckIn />} />
                                    </Route> */}
                                    {/* <Route path={''} element={<BackStageSider type={"CheckOut"} />}>
                                        <Route path={'CheckOut'} element={<BackStageCheckOut />} />
                                        <Route path={'CheckOut/:borrowernumber'} element={<BackStageCheckOut />} />
                                        <Route path={'PatronDetail'} element={<BackStagePatronDetail />} />
                                    </Route> */}
                                    {/* <Route path={'CheckOut'} element={<BackStageCheckOut />} /> */}
                                    <Route path={'CheckoutSetting'} element={<BackStageCheckOutSetting permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "CheckoutSetting"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                    <Route path={'RenewSetting'} element={<BackStageRenewSetting permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "RenewSetting"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                    <Route path={'HoldSetting'} element={<BackStageHoldSetting permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "HoldSetting"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                    {/* <Route path={'HoldSetting/:borrowernumber'} element={<BackStageHoldSetting />} /> */}
                                    <Route path={'HoldPriority'} element={<BackStageHoldPriority />} />
                                    <Route path={'Rules'} element={<BackStageCirculationRules permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "Rules"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                </Route>
                                <Route path={'borrow'} element={<Borrow />} />
                                <Route path={'book_return'} element={<BookReturn />} />
                                <Route path={'overdue_processing'} element={<OverdueProcessing />} />


                                {/* Patrons */}
                                {/* <Route path={'SearchPatrons'} element={<SearchPatrons />} /> */}
                                {/* <Route path={"PatronDetail"} element={<BackStagePatronDetailLayout />} > */}

                                {/* <Route path={''} element={<Mainlayout />}>
                                    <Route path={'Patrons/:borrowernumber'} element={<BackStagePatrons />} />
                                    <Route path={'Patrons'} element={<BackStagePatrons />} />
                                    <Route path={'Patron/:user_id'} element={<BackStageNewOrEditPatron />} />
                                    <Route path={'NewPatron'} element={<BackStageNewPatron />} />
                                    <Route path={'NewPatron/:categorycode'} element={<BackStageNewOrEditPatron />} />
                                    <Route path={'EditPatron/:borrowernumber'} element={<BackStageNewOrEditPatron />} />
                                    <Route path={'PatronCategories'} element={<BackStagePatronCategories />} />
                                    <Route path={'PatronCategory/:categorycode'} element={<BackStageNewOrEditPatronCategory />} />
                                </Route> */}
                                {/* <Route path={''} element={<BackStageSider type={"PatronPermissions"} />}>
                                    <Route path={'PatronPermissions/:borrowernumber'} element={<BackStagePatronPermissions />} />
                                </Route> */}
                                <Route path={'Patrons'} >
                                    <Route path={'CheckOutHistory'} element={<BackStageCheckOutHistory permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "CheckOutHistory"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                </Route>

                                {/* authorised_values 系統授權值管理 */}
                                {/* <Route path={'authorized_values_management'}  >
                                    <Route path={''} element={<BackStageAuthorisedValues />} />
                                    <Route path={'New'} element={<BackStageAuthorisedValuesCategoryNew />} />
                                    <Route path={':category'} element={<BackStageAuthorisedValuesCategory />} />
                                    <Route path={':category/New'} element={<BackStageAuthorisedValuesNewOrEdit />} />
                                    <Route path={':category/:id'} element={<BackStageAuthorisedValuesNewOrEdit />} />
                                </Route> */}

                                {/* authority 權威控制 先暫緩 */}
                                {/* <Route path={'authority'}>
                                    <Route path={''} element={<BackStageAuthority />} />
                                </Route> */}
                                {/* MainRouteKoha 內含授權值管理、分館管理 */}
                                <Route path={'*'} element={<MainRouteKoha />} />
                                {/* serials_management 連續性出版品設定 */}
                                <Route path={'serials_management'} element={<SerialsManagement permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data_all?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "serials_management"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                <Route path={'serial_frequency_management'} element={<SerialFrequencyManagement permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data_all?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "serial_frequency_management"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                <Route path={'serial_code_management'} element={<SerialCodeManagement permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data_all?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "serial_code_management"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                {/* library_transfer_limit_management ccode分類館藏轉移館際設定 */}
                                <Route path={'library_transfer_limit_management'} element={<LibraryTransferLimitManagement permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "library_transfer_limit_management"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                <Route path={'library_transfer_management'} element={<LibraryTransferManagement permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "library_transfer_management"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                <Route path={'reader_review_management'} element={<ReaderReviewManagement />} />
                                <Route path={'new_arrivals_list_management'} element={<NewArrivalsList />} />
                                <Route path={'system_backup_settings'} element={<SystemBackupSettings />} />

                                {/* <Route path={''} element={<Mainlayout noCard />}>
                                        <Route path={'ReaderService'} element={<ReaderService />}>
                                        </Route>
                                    </Route> */}
                                {/* 使用者管理 */}
                                <Route path="department_patron_categories" element={<DepartmentPatronCategories permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "department_patron_categories"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                <Route path="departmentRole" element={<DepartmentRoleManagement mode={'departmentRole'} key={'departmentRole'} />} />
                                <Route path="department" element={<DepartmentRoleManagement mode={'department'} key={'department'} />} />
                                <Route path="role" element={<DepartmentRoleManagement mode={'role'} key={'role'} permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "role"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                <Route path="depth" element={<DepthDataManagement backEditPath="department_patron_categories" />} />
                                {/* 模組 */}
                                <Route path="staff" element={<Staff />} />
                                {/* 子系統 */}
                                <Route path="staff_patron" element={<StaffPatron permission_level={StaffDivergeSelfData?.find(_ => true)?.permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "staff_patron"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
                                <Route path="frontend_basic_settings/*" element={<MainRouteOnlinePublicCatalogQueryConstruction propsPath="/library/backstage/frontend_basic_settings" user_permission_data={StaffDivergeSelfData?.find(_ => true)?.permission_data_all} />} />
                                <Route path={'app/*'} element={<AppMainRoute admin={true} />}>{/* true是要登入的 false是只會剩下形象的前台 */}
                                </Route>
                                <Route path={'library_opening_hours_management'} element={<LibraryOpeningHoursManagement />} />
                                <Route path={'space_management'} element={<SpaceManagement depth={0} only_depth />}></Route>
                                <Route path={'week_management'} element={<WeekManagement />}></Route>
                            </Route>
                            <Route path={'organization_structure/*'} element={<RouteOrganizationStructure />} />
                            <Route path={'library_management'}
                                element={<LibraryOpenHourManagement
                                />}
                            />
                            <Route path="holiday_management" >
                                <Route path="" element={
                                    <HolidayManagement />
                                } />
                                <Route path="detail" element={
                                    <HolidayDetailManagement />
                                } />
                            </Route>
                            {/* 報表 */}
                            <Route path={'*'}
                                element={<MainCataloging
                                    allRouteKeys={[
                                        'total_holdings',
                                        'holdings_added',
                                        'holdings_removed'
                                    ]}
                                />}
                            />
                            <Route path={'daily_circulation_statistics'}
                                element={<DailyCirculationStatistics />}
                            />
                            <Route path={'circulation_trend_analysis'}
                                element={<CirculationTrendAnalysis />}
                            />
                            <Route path={'overdue_report'}
                                element={<OverdueReport />}
                            />
                        </Route>
                    </Route>
                </Route>
                {/* <Route path={'CategorizationGroupONE'} element={<CategorizationGroupONE />} />
                <Route path={'CategorizationGroupTWO'} element={<CategorizationGroupTWO />} /> */}
            </>}

            {/* 前台 */}
            <Route path={'*'}
                {...(app !== '1' ? {
                    element:
                        <ComponentLayout
                            menuData={menuDataFronted}
                        />
                } : {}
                )}
            >
                <Route path={'online_public_catalog_query_construction/*'} element={<MainRouteLibraryFront />} >
                </Route>
                <Route path={''}
                    {...jwt}
                >
                    <Route path={'personal_info_query'} element={<PersonalInfoQuery />}>
                    </Route>
                    <Route path={'personal_study'} element={<PersonalStudy />}>
                    </Route>
                    <Route path={'message_notification'} element={<MessageInbox />}>
                    </Route>
                </Route>
                <Route path={'login_required'} element={<LoginRequired loginPagePath={admin ? "/login" : "/user_login"} homePagePath="/library/online_public_catalog_query_construction" />}>
                </Route>
            </Route>
        </Routes>
    </>)
}

export default MainRoute
